import { useEffect } from 'react';
import { completeOnboardingStep } from './OnboardingProvider';

/** Автозачёт шага чеклиста при открытии страницы (дополнение к backend). */
export function useOnboardingPageStep(stepKey, roles) {
  useEffect(() => {
    const role = localStorage.getItem('role') || '';
    if (roles && !roles.includes(role)) return;
    void completeOnboardingStep(stepKey);
  }, [stepKey, roles]);
}
